//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            frequency: 'Monthly',
            frequencyEnd: 'Never',
            frequencyEndDate: null,
            properties: [],
            property: '',
            period: moment(),
            transaction_date: moment().format("MM/DD/YYYY"),
            cash: true,
            accrual: true,
            recurring: true,
            accounts: [],
            lines: [],
            errors: [],
            id: null
        };
    },

    methods: {
        checkCreditEnabled: function checkCreditEnabled(idx) {
            if (Number(this.lines[idx].credit) === 0 && Number(this.lines[idx].debit) === 0) {
                return false;
            } else {
                if (this.lines[idx].debit != "" && Number(this.lines[idx].debit) != 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        checkDebitEnabled: function checkDebitEnabled(idx) {
            if (Number(this.lines[idx].credit) === 0 && Number(this.lines[idx].debit) === 0) {
                return false;
            } else {
                if (this.lines[idx].credit != '' && Number(this.lines[idx].credit) != 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        addLine: function addLine() {
            this.lines.push({
                account: null,
                description: '',
                credit: '0.00',
                debit: '',
                id: null
            });
        },
        close: function close() {
            Event.$emit('close-full-modal');
        },
        deleteLine: function deleteLine(idx) {
            this.lines.splice(idx, 1);
        },
        post: function post() {
            var _this = this;

            this.errorsAccount = [];
            this.errorsDesc = [];
            this.lines.map(function (line) {
                if (line.account == null || line.account == '') _this.errorsAccount.push('Account is required');
                if (line.description == null || line.description == '') _this.errorsDesc.push('Description is required');
            });
            if (this.errorsAccount.length || this.errorsDesc.length) {
                if (this.errorsAccount.length) {
                    this.$snotify.error('All account related fields are required');
                } else {
                    this.$snotify.error('All description fields are required');
                }
            } else {
                var formData = new FormData();
                formData.append("id", this.id);
                formData.append("property", this.property.id);
                formData.append("period", this.period);
                formData.append("transaction_date", this.transaction_date);
                formData.append("recurring", JSON.stringify(this.recurring));
                formData.append("cash", JSON.stringify(this.cash));
                formData.append("accrual", JSON.stringify(this.accrual));
                formData.append("lines", JSON.stringify(this.lines));
                formData.append("frequency", this.frequency);
                formData.append("frequencyEnd", this.frequencyEnd);
                if (this.frequencyEndDate != null && this.frequencyEndDate != '' && this.frequencyEndDate != 'Invalid date') {
                    formData.append("frequencyEndDate", this.frequencyEndDate);
                }
                formData.append("nextRunDate", this.nextRunDate);

                axios.post('/prototype/accounting/general-ledger/recurring-journal-entry/store', formData).then(function (response) {
                    _this.$snotify.success('The journal entry was saved');
                    Event.$emit('refresh-recurring-journal-entries');
                    Event.$emit('close-full-modal');
                });
            }
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        var $el = this;

        Event.$on('recurring-journal-entry', function () {
            Object.assign(_this2.$data, _this2.$options.data());

            // assign empty lines
            _this2.lines.push({
                account: null,
                description: '',
                credit: '0.00',
                debit: '',
                id: null
            }, {
                account: null,
                description: '',
                credit: '',
                debit: '0.00',
                id: null
            });

            $el.$children[0].$data.showModal = true;

            axios.get('/prototype/properties/quick/lookup').then(function (response) {
                $el.properties = response.data.properties;
                $el.property = response.data.selected;
            });
            axios.post('/prototype/accounting/general-ledger/accounts/fetch').then(function (response) {
                $el.accounts = response.data;
            });
        });

        Event.$on('update-recurring-journal-entry', function (item) {
            Object.assign(_this2.$data, _this2.$options.data());
            _this2.id = item.id;
            _this2.frequency = _this2.frequency;
            _this2.frequencyEndDate = moment(item.ends_at).format("MM/DD/YYYY");
            _this2.property = item.property_id;
            _this2.period = item.period;
            _this2.transaction_date = moment(item.transaction_date).format("MM/DD/YYYY");
            _this2.cash = item.is_cash;
            _this2.accrual = item.is_accrual;
            _this2.recurring = item.recurring;
            _this2.lines = item.entries;

            if (item.ends_at != null) {
                _this2.frequencyEnd = 'On Certain Date';
            }

            //convvert entries for select list
            _this2.lines.map(function (line) {
                line.account = {
                    id: line.account.id,
                    label: line.account.number + ' - ' + line.account.name
                };
            });

            $el.$children[0].$data.showModal = true;

            axios.get('/prototype/properties/quick/lookup').then(function (response) {
                $el.properties = response.data.properties;
                $el.property = response.data.selected;
            });
            axios.post('/prototype/accounting/general-ledger/accounts/fetch').then(function (response) {
                $el.accounts = response.data;
            });
        });
    },


    computed: {
        nextRunDate: function nextRunDate() {

            if (this.frequency == 'Monthly') {
                return moment(this.transaction_date, "MM/DD/YYYY").add(1, 'M').format("MM/DD/YYYY");
            }
            if (this.frequency == 'Quarterly') {
                return moment(this.transaction_date, "MM/DD/YYYY").add(3, 'M').format("MM/DD/YYYY");
            }
            if (this.frequency == 'Annually') {
                return moment(this.transaction_date, "MM/DD/YYYY").add(12, 'M').format("MM/DD/YYYY");
            }
        },
        totalDebits: function totalDebits() {
            return Number.parseFloat(this.lines.reduce(function (prev, cur) {
                return prev + Number.parseFloat(cur.debit);
            }, 0)).toFixed(2);
        },
        totalCredits: function totalCredits() {
            return Number.parseFloat(this.lines.reduce(function (prev, cur) {
                return prev + Number.parseFloat(cur.credit);
            }, 0)).toFixed(2);
        },
        valid: function valid() {
            var _this3 = this;

            this.errors = [];
            this.lines.map(function (line) {
                if (line.account == null || line.account == '') _this3.errors.push('Account is required');
                if (line.description == null || line.description == '') _this3.errors.push('Description is required');
            });
            return this.errors.length;
        },
        canPostTo: function canPostTo() {
            return this.accounts.filter(function (account) {
                return account.can_post_to === 1;
            });
        },
        accountNames: function accountNames() {
            return this.canPostTo.map(function (account) {
                return {
                    id: account.id,
                    label: account.number + ' - ' + account.name
                };
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/journal-entry/RecurringJournalEntry.vue
// module id = TpWX
// module chunks = 0 1